import type {
  PhoneNumber,
  PhoneNumberCreateInput,
  PhoneNumberListResponse,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const phoneNumbersApi = {
  list() {
    return request<PhoneNumberListResponse>("/admin/phone-numbers");
  },
  assign(input: PhoneNumberCreateInput) {
    return request<{ phone_number: PhoneNumber }>("/admin/phone-numbers", {
      method: "POST",
      body: input,
    });
  },
  release(id: string) {
    return request<{ ok: true }>(`/admin/phone-numbers/${id}`, {
      method: "DELETE",
    });
  },
};
